import { render } from "./ActivePrj.vue?vue&type=template&id=39ebc90d&scoped=true"
import script from "./ActivePrj.vue?vue&type=script&lang=js"
export * from "./ActivePrj.vue?vue&type=script&lang=js"

import "./ActivePrj.vue?vue&type=style&index=0&id=39ebc90d&lang=css"
import "./ActivePrj.vue?vue&type=style&index=1&id=39ebc90d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ebc90d"]])

export default __exports__